import { render, staticRenderFns } from "./PublicGamesTable.vue?vue&type=template&id=cf96e6de&scoped=true&"
import script from "./PublicGamesTable.vue?vue&type=script&lang=js&"
export * from "./PublicGamesTable.vue?vue&type=script&lang=js&"
import style0 from "./PublicGamesTable.vue?vue&type=style&index=0&id=cf96e6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf96e6de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
